"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Arrow = exports.ARROW_TYPE = exports.ARROW_CLASS_NAME_PREV = exports.ARROW_CLASS_NAME_NEXT = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("b2b-components/theme/components/Icon");
var _classnames = _interopRequireDefault(require("classnames"));
var _upperCaseFirst = require("upper-case-first");
require("./Arrow.scss");
var ARROW_TYPE = /*#__PURE__*/function (ARROW_TYPE) {
  ARROW_TYPE["next"] = "next";
  ARROW_TYPE["prev"] = "prev";
  return ARROW_TYPE;
}(ARROW_TYPE || {});
exports.ARROW_TYPE = ARROW_TYPE;
var ARROW_CLASS_NAME_NEXT = 'cds-Gallery-Arrow--Next';
exports.ARROW_CLASS_NAME_NEXT = ARROW_CLASS_NAME_NEXT;
var ARROW_CLASS_NAME_PREV = 'cds-Gallery-Arrow--Prev';
exports.ARROW_CLASS_NAME_PREV = ARROW_CLASS_NAME_PREV;
var Arrow = function Arrow(_ref) {
  var className = _ref.className,
    isPreview = _ref.isPreview,
    type = _ref.type,
    onClick = _ref.onClick,
    isDisabled = _ref.isDisabled;
  var rootClassName = (0, _classnames["default"])(className, 'cds-Gallery-Arrow', "cds-Gallery-Arrow--".concat((0, _upperCaseFirst.upperCaseFirst)(type)), {
    'cds-Gallery-Arrow--Preview': isPreview,
    'cds-Gallery-Arrow--Disabled': isDisabled
  });
  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({}, !isDisabled && {
    onClick: onClick
  }, {
    className: rootClassName
  }), /*#__PURE__*/_react["default"].createElement(_Icon.Icon, {
    name: type === ARROW_TYPE.prev ? _Icon.ICON_NAME.arrowLeft : _Icon.ICON_NAME.arrowRight
  }));
};
exports.Arrow = Arrow;
Arrow.config = {
  arrowType: ARROW_TYPE
};